module.exports = __webpack_public_path__ + "static/media/icon-shopping-bag.dd75d800.svg";